import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class ActualizacionStockService {

  controller: string = "actualizacion-stock/";

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) { }

  insert(actualizacion_stock: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'crear', actualizacion_stock, this.sesion.headers);
  }

  update(actualizacion_stock: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'actualizar/' + actualizacion_stock.id, actualizacion_stock, this.sesion.headers);
  }

  delete(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + "eliminar/" + id, this.sesion.headers);
  }
}
